import { colors } from 'Constants/Colors';

export const errorTextHelper = {
  margin: '0',
  paddingLeft: '0.5rem',
  paddingTop: '0.25rem',
};

export const inputStyle = {
  backgroundColor: colors.WHITE,
};

export default {
  errorTextHelper,
  inputStyle,
};
